import React, { FC, useCallback, useContext, useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { SelectOption } from '../../../../../Components/Form/Form.types';
import {
  ListFilter,
  createSelectFilter,
  createMultiSelectFilter,
} from '../../../../../Components/ListFilter/ListFilter';
import { UserContext } from '../../../../../Context/UserContext/UserContext';
import { useAptorApi, useFetchFilterOptions } from '../../../../../Api';
import { entityToSelectlebelOption, OptionsEntity } from '../../../../../Utilities';
import { INamedEntity } from '../../../../../Api/AptorApi';
import { updateFilterOptionsDependentOnCompanyUnit } from '../../../../../Components/ListFilter/filterUtils';

interface IOptions extends OptionsEntity {
  areas: SelectOption[];
  categories: SelectOption[];
  companyUnits: SelectOption[];
  complianceUsers: SelectOption[];
  statuses: SelectOption[];
  processes: SelectOption[];
  aspects: SelectOption[];
  tags: SelectOption[];
}

interface IProps {
  companyUnit?: INamedEntity;
  filters: any;
  setFilter: (field: string, values: string[] | { min?: Date; max?: Date } | undefined) => void;
  disable?:boolean;
}

export const LawListFilter: FC<IProps> = ({ companyUnit, filters, setFilter,disable}) => {
  const { getCompanyUnitName, getProcessName, getAspectName, getTagName } = useContext(UserContext);
  const { formatMessage } = useIntl();
  const { api, abortController } = useAptorApi();
  const [allOptions, , , userCompanyUnits] = useFetchFilterOptions<IOptions>(
    useCallback(() => api.getLawPortalLawFilters(), [api]),
    abortController,
  );

  const [options, setOptions] = useState<IOptions | null>(null);

  useEffect(() => {
    setOptions(allOptions);
  }, [allOptions]);

  const onSetFilter = (field: string, values: string[] | { min?: Date; max?: Date } | undefined) => {
    setFilter(field, values);
    updateFilterOptionsDependentOnCompanyUnit(
      field,
      values,
      setOptions,
      allOptions,
      filters,
      setFilter,
      userCompanyUnits,
    );
  };

  /* Hacky solution: Try to improve
     Emulates company unit has been set manually after allOptions have
     been loaded so that dependant filter can update themselves
  */
  useEffect(() => {
    if (allOptions && companyUnit) {
      updateFilterOptionsDependentOnCompanyUnit(
        'companyUnit',
        [companyUnit.name],
        setOptions,
        allOptions,
        filters,
        setFilter,
        userCompanyUnits,
      );
    }
  }, [allOptions, companyUnit, filters, setFilter, userCompanyUnits]);

  // const companyUnitFilter = createSelectFilter(
  //   'companyUnit',
  //   getCompanyUnitName(formatMessage),
  //   options?.companyUnits,
  //   undefined,
  //   companyUnit ? entityToSelectOption(companyUnit) : undefined,
  //   undefined,
  //   Boolean(companyUnit),
  // );
  // const companyUnitFilter = createSelectFilter(
  //   'companyUnit',
  //   getCompanyUnitName(formatMessage),
  //   options?.companyUnits,
  //   (option) => option.value.toString(),
  //   undefined,
  //   filters.companyUnit,
  // );
  const companyUnitFilter = createSelectFilter(
    'companyUnit',
    getCompanyUnitName(formatMessage),
    options?.companyUnits?.map(entityToSelectlebelOption),
    (option) => option.value.toString(),
    undefined,
    filters.companyUnit,
   disable?true:false,
  );

  // const areaFilter = createSelectFilter('area', formatMessage({ id: 'utils.filters.area' }), options?.areas);

  const areaFilter = createSelectFilter(
    'area',
    formatMessage({ id: 'law-portal.our-laws.table.area' }),
    options?.areas?.map(entityToSelectlebelOption),
    (option) => option.value.toString(),
    undefined,
    filters.area,
  );
  // const categoryFilter = createSelectFilter(
  //   'category',
  //   formatMessage({ id: 'utils.filters.category' }),
  //   options?.categories,
  // );
  const categoryToSelectOption = (option: SelectOption): SelectOption => ({
    value: option.label,
    label: option.description || option.label,
  });
  const categoryFilter = createSelectFilter(
    'category',
    formatMessage({ id: 'utils.filters.category' }),
    options?.categories?.map(categoryToSelectOption),
    (option) => option.value.toString(),
    undefined,
    filters.category,
  );

  const complianceUsersFilter = createMultiSelectFilter(
    'complianceUsers',
    formatMessage({ id: 'utils.filters.complianceUsers' }),
    options?.complianceUsers,
    (option) => option.value?.toString(),
    undefined,
    filters.complianceUsers as string[],
  );

  const activeOption = { value: 1, label: formatMessage({ id: 'utils.filters.status.active' }) };

  const statusFilter = createSelectFilter(
    'status',
    formatMessage({ id: 'utils.filters.status' }),
    options?.statuses,
    (option) => option.value?.toString(),
    activeOption,
  );

  const processesFilter = createMultiSelectFilter(
    'processes',
    // formatMessage({ id: 'utils.filters.processes' }),
    getProcessName(formatMessage),
    options?.processes,
    (option) => option.value.toString(),
    undefined,
    filters.processes as string[],
  );

  const aspectsFilter = createMultiSelectFilter(
    'aspects',
    // formatMessage({ id: 'utils.filters.aspects' }),
    getAspectName(formatMessage),
    options?.aspects,
    (option) => option.value.toString(),
    undefined,
    filters.aspects as string[],
  );

  const tagsFilter = createMultiSelectFilter(
    'tags',
    // formatMessage({ id: 'utils.filters.tags' }),
    getTagName(formatMessage),
    options?.tags,
    (option) => option.value.toString(),
    undefined,
    filters.tags as string[],
  );

  return (
    <ListFilter
      filters={[
        companyUnitFilter,
        complianceUsersFilter,
        processesFilter,
        aspectsFilter,
        tagsFilter,
        areaFilter,
        categoryFilter,
        statusFilter,
      ]}
      setFilter={onSetFilter}
    />
  );
};
